import React from 'react';
import './footer.scss';
import { BackTop } from 'antd';

function Footer() {
    return (
       <div className="footer">
          <a href="http://uigreat.com/" target="_blank">优阁网-UIGREAT</a> & <a href="http://www.motiongreat.com" target="_blank">MotionGreat</a> <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">京ICP备15031701号-2</a>
          <BackTop />
       </div>
    );
}

export default Footer;